module.exports = __webpack_public_path__ + "static/media/libin.0bea61cd.png";